export const domReady = () =>
  new Promise((resolve) => {
    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", resolve, { once: true });
    } else {
      resolve();
    }
  });

export const waitForIdle = () =>
  new Promise((resolve) => {
    if ("requestIdleCallback" in window) {
      requestIdleCallback(resolve, { timeout: 1000 });
    } else {
      setTimeout(resolve, 100);
    }
  });
